import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=c8d61bf6"
import script from "./Accounting.vue?vue&type=script&lang=js"
export * from "./Accounting.vue?vue&type=script&lang=js"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=c8d61bf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports